export const adrEntitySeverityFactory = adrEntitySeverity;

// <adr-entity-severity entity="" update-entity="updateEntity(entity, ui)"></adr-entity-severity>
function adrEntitySeverity() {
    var directive = {
        restrict: 'E',
        templateUrl: 'js/entity.severity.directive.html',
        scope: {
            entity: '=',
            updateEntity: '&',
        },
        controller: ['$scope', EntitySeverityController],
        controllerAs: 'vm',
        bindToController: true,
    };

    return directive;

    function EntitySeverityController($scope) {
        // placeholder for vm
        //
    }
}
